// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ci-commit-tag-link[data-v-133d9096]{position:absolute;top:-webkit-calc(100% + 5px);top:calc(100% + 5px);left:5px;padding:5px;background:#fff;border-radius:5px;border:1px solid #000}", ""]);
// Exports
module.exports = exports;
